export const content = `Deciding to attend therapy is an important first step to prioritizing your mental health. Ready to begin therapy with us?

[**Start the matching process**](/onboarding/welcome)

1. Fill out some basic information, like your location, age, insurance, and what you want to address in therapy.
2. Select the type of care you’re seeking.
3. Add any other factors that matter for you, like your provider’s identity or experience working with specific communities.
4. Create your account.
5. Review your matches and book your first session.
`;
